import { callable } from './callable'
import { normalizeTierId, type TierId } from '../config/PricingConfig'
import { testingOverrideAllowsAllFeatures } from '../config/testingOverrides'

export type QuotaOperation = 'FORM_CREATE' | 'FORM_RESPONSE'
export type WorkspacePlan = TierId

export const normalizeWorkspacePlan = (plan: unknown): WorkspacePlan => normalizeTierId(plan)

export const checkWorkspaceQuota = async (workspaceId: string, operation: QuotaOperation) => {
  if (testingOverrideAllowsAllFeatures()) {
    return { allowed: true, used: 0, limit: Number.POSITIVE_INFINITY, plan: 'ENTERPRISE_TIER' as WorkspacePlan }
  }
  const result = await callable<
    { workspaceId: string; operation: QuotaOperation },
    { allowed: boolean; used: number; limit: number; plan: string }
  >('checkFormQuota', { workspaceId, operation })

  const limit = result.limit === -1 ? Number.POSITIVE_INFINITY : result.limit
  return {
    allowed: result.allowed,
    used: result.used,
    limit,
    plan: normalizeWorkspacePlan(result.plan),
  }
}

export const assertWorkspaceQuota = async (workspaceId: string, operation: QuotaOperation) => {
  const result = await checkWorkspaceQuota(workspaceId, operation)
  if (!result.allowed) throw new Error(`${operation.replaceAll('_', ' ').toLocaleLowerCase()} quota reached (${result.used}/${result.limit}).`)
  return result
}
